import script from "./SwitchButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchButton.vue?vue&type=script&setup=true&lang=js"

import "./SwitchButton.vue?vue&type=style&index=0&id=497e040c&scoped=true&lang=scss"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497e040c"]])

export default __exports__